import { render, staticRenderFns } from "./TabProductInfo.vue?vue&type=template&id=e36abfa0&scoped=true&"
import script from "./TabProductInfo.vue?vue&type=script&lang=js&"
export * from "./TabProductInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36abfa0",
  null
  
)

export default component.exports